var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.numericInputDialog },
        on: {
          "update-value":
            _vm.handleMultipleAlternativesAttributeValueUpdateCommand,
        },
      }),
      _vm._v(" "),
      _c("ListSelectionDialog", {
        attrs: { viewModel: _vm.statusListSelectionDialog },
        on: {
          "update-value": _vm.handleUpdateMultipleAlternativesStatusCommand,
        },
      }),
      _vm._v(" "),
      _c("ListSelectionDialog", {
        attrs: { viewModel: _vm.attrListSelectionDialog },
        on: {
          "update-value":
            _vm.handleMultipleAlternativesAttributeValueUpdateCommand,
        },
      }),
      _vm._v(" "),
      _c("StaticViewBuilder", {
        attrs: { viewModel: _vm.staticViewBuilder },
        on: { "create-static-list": _vm.handleCreateStaticViewCommand },
      }),
      _vm._v(" "),
      _c("ReportEditor", {
        attrs: { viewModel: _vm.reportEditor },
        on: { "update-report": _vm.handleUpdateReportCommand },
      }),
      _vm._v(" "),
      _c("AlternativeEditorDialog", {
        attrs: { viewModel: _vm.alternativeEditorDialog },
      }),
      _vm._v(" "),
      _c("AlternativesComparisonDialog", {
        attrs: { viewModel: _vm.alternativesComparisonDialog },
      }),
      _vm._v(" "),
      _c("KendoChartFullScreenDialog", {
        attrs: {
          propOpened: _vm.fullScreenChart != null,
          propChart: _vm.fullScreenChart?.Chart,
          propTitle: _vm.fullScreenChart?.Title,
        },
        on: {
          "close-dialog": function ($event) {
            _vm.fullScreenChart = null
          },
        },
      }),
      _vm._v(" "),
      _c("KendoGridColumnsEditorDialog", {
        attrs: {
          propOpened: _vm.kendoGridColumnsEditorDialogOpened,
          propGrid: _vm.grid,
        },
        on: {
          "close-dialog": function ($event) {
            _vm.kendoGridColumnsEditorDialogOpened = false
          },
        },
      }),
      _vm._v(" "),
      !_vm.rm
        ? _c("h3", [
            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
            _vm._v(" Loading..."),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.rm?.IsWorkspaceUser
        ? _c("PortfolioOrDecisionNavigation", {
            attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.rm
        ? _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-10 offset-lg-1",
                  staticStyle: { "padding-top": "130px" },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-6" }, [
                      _vm.rm.Readonly
                        ? _c("div", [
                            _c(
                              "h1",
                              {
                                staticStyle: {
                                  "font-size": "2em",
                                  "font-weight": "300",
                                  color: "#33475b",
                                  margin: "0",
                                },
                              },
                              [_vm._v(_vm._s(_vm.rm.Report.Name))]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "lead" }, [
                              _vm._v(_vm._s(_vm.rm.Report.Description)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.rm.Readonly
                        ? _c(
                            "div",
                            {
                              staticClass: "pointer",
                              on: { click: _vm.showReportEditor },
                            },
                            [
                              _c(
                                "h1",
                                {
                                  staticStyle: {
                                    "font-size": "2em",
                                    "font-weight": "300",
                                    color: "#33475b",
                                    margin: "0",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "editable editable-success",
                                    },
                                    [_vm._v(_vm._s(_vm.rm.Report.Name))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "lead" }, [
                                _vm._v(_vm._s(_vm.rm.Report.Description)),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    !_vm.rm.Readonly
                      ? _c(
                          "div",
                          { staticClass: "col-lg-6 text-right align-self-end" },
                          [
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Create\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: { click: _vm.createMetric },
                                    },
                                    [_vm._v("Metric")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: { click: _vm.createScatterChart },
                                    },
                                    [_vm._v("Scatter plot")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: { click: _vm.createBalancingChart },
                                    },
                                    [_vm._v("Column chart")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: { click: _vm.createBubbleChart },
                                    },
                                    [_vm._v("Bubble chart")]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/sharing/resource/ReportsDataShareResourceProvider/${_vm.reportId}`,
                                    expression:
                                      "`/#/sharing/resource/ReportsDataShareResourceProvider/${reportId}`",
                                  },
                                ],
                                staticClass: "btn btn-outline-secondary",
                              },
                              [_vm._v("Share")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click:
                                    _vm.handleUpdatePortfolioBalancerReportCommand,
                                },
                              },
                              [_vm._v("Save")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("hr", {
              staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-10 offset-lg-1" }, [
                !_vm.rm.Readonly
                  ? _c("div", { staticClass: "card bg-light" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "container-fluid" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Filter by list:")]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.SelectedList,
                                        expression: "SelectedList",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.SelectedList = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [_vm._v("All")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.rm.Lists, function (list) {
                                      return _c(
                                        "option",
                                        {
                                          key: list.Id,
                                          domProps: { value: list },
                                        },
                                        [_vm._v(_vm._s(list.Name))]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [
                                  _vm._v("Group by text attribute:"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.GroupByAttribute,
                                        expression: "GroupByAttribute",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.GroupByAttribute = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [_vm._v("No grouping")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.TextAttributes,
                                      function (attribute) {
                                        return _c(
                                          "option",
                                          {
                                            key: attribute.Id,
                                            domProps: { value: attribute },
                                          },
                                          [_vm._v(_vm._s(attribute.Name))]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("Edit form:")]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.Form,
                                        expression: "Form",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.Form = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [_vm._v("None")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.rm.Forms, function (form) {
                                      return _c(
                                        "option",
                                        {
                                          key: form.Id,
                                          domProps: { value: form },
                                        },
                                        [_vm._v(_vm._s(form.Name))]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.Metrics, function (m) {
                    return _c(
                      "div",
                      {
                        key: m.MetricId,
                        staticClass: "mt-3",
                        class: m.WidthCss,
                      },
                      [
                        !m.IsEdited
                          ? _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-header" }, [
                                !_vm.rm.Readonly
                                  ? _c(
                                      "div",
                                      { staticClass: "dropdown float-right" },
                                      [
                                        _vm._m(0, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-menu dropdown-menu-right",
                                            attrs: { role: "menu" },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    m.IsEdited = true
                                                  },
                                                },
                                              },
                                              [_vm._v("Edit")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return m.clone()
                                                  },
                                                },
                                              },
                                              [_vm._v("Clone")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return m.moveUp()
                                                  },
                                                },
                                              },
                                              [_vm._v("Move up")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return m.moveDown()
                                                  },
                                                },
                                              },
                                              [_vm._v("Move down")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "h6",
                                              {
                                                staticClass: "dropdown-header",
                                              },
                                              [_vm._v("Width")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    m.Size = "1/4"
                                                  },
                                                },
                                              },
                                              [_vm._v("1/4")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    m.Size = "1/3"
                                                  },
                                                },
                                              },
                                              [_vm._v("1/3")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    m.Size = "1/2"
                                                  },
                                                },
                                              },
                                              [_vm._v("1/2")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return m.deleteMetric()
                                                  },
                                                },
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("h5", [_vm._v(_vm._s(m.Title))]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "card-body" }, [
                                _c("h4", [
                                  _c("span", { style: { color: m.Color } }, [
                                    _vm._v(_vm._s(m.ValueStr)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  m.LimitMin != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(m.LimitMinStr)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    " \n                                    "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  m.LimitMax != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(m.LimitMaxStr)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" \n                                "),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        m.IsEdited
                          ? _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _c("div", { staticClass: "float-right" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function ($event) {
                                          return m.closeEditor()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa fa-check fa-lg",
                                        staticStyle: { "z-index": "100" },
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("h5", [_vm._v("Edit metric")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _c("h6", [_vm._v("Title:")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: m.Title,
                                          expression: "m.Title",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text" },
                                      domProps: { value: m.Title },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            m,
                                            "Title",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row mt-3" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c("h6", [_vm._v("Attribute:")]),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: m.Attribute,
                                              expression: "m.Attribute",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                m,
                                                "Attribute",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("Number of projects")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.NumericAttributes,
                                            function (attr) {
                                              return _c(
                                                "option",
                                                {
                                                  key: attr.Id,
                                                  domProps: { value: attr },
                                                },
                                                [_vm._v(_vm._s(attr.Name))]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    m.Attribute
                                      ? _c("div", { staticClass: "col-md-6" }, [
                                          _c("h6", [_vm._v("Type:")]),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: m.Type,
                                                  expression: "m.Type",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    m,
                                                    "Type",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              _vm.MetricTypes,
                                              function (t) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: t,
                                                    domProps: { value: t },
                                                  },
                                                  [_vm._v(_vm._s(t))]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  m.Attribute
                                    ? _c("div", { staticClass: "row mt-3" }, [
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c("h6", [_vm._v("Currency:")]),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: m.Currency,
                                                  expression: "m.Currency",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    m,
                                                    "Currency",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { domProps: { value: null } },
                                                [_vm._v("None")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.Currencies,
                                                function (c) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: c,
                                                      domProps: { value: c },
                                                    },
                                                    [_vm._v(_vm._s(c))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c("h6", [_vm._v("Decimal places:")]),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: m.Decimals,
                                                  expression: "m.Decimals",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    m,
                                                    "Decimals",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { domProps: { value: null } },
                                                [_vm._v("All")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.DecimalsOptions,
                                                function (d) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: d,
                                                      domProps: { value: d },
                                                    },
                                                    [_vm._v(_vm._s(d))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row mt-3" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c("h6", [_vm._v("Min:")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value: m.LimitMin,
                                            expression: "m.LimitMin",
                                            modifiers: { number: true },
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "number" },
                                        domProps: { value: m.LimitMin },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              m,
                                              "LimitMin",
                                              _vm._n($event.target.value)
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c("h6", [_vm._v("Max:")]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value: m.LimitMax,
                                            expression: "m.LimitMax",
                                            modifiers: { number: true },
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "number" },
                                        domProps: { value: m.LimitMax },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              m,
                                              "LimitMax",
                                              _vm._n($event.target.value)
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("h6", [_vm._v("Statuses:")]),
                                  _vm._v(" "),
                                  _vm._l(
                                    m.AlternativesStatusIncludes,
                                    function (s) {
                                      return _c("p", { key: s.Id }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: s.Included,
                                              expression: "s.Included",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(s.Included)
                                              ? _vm._i(s.Included, null) > -1
                                              : s.Included,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = s.Included,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      s,
                                                      "Included",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      s,
                                                      "Included",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(s, "Included", $$c)
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(s.Name) +
                                            "\n                                "
                                        ),
                                      ])
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "card-footer text-right" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-success",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return m.closeEditor()
                                        },
                                      },
                                    },
                                    [_vm._v("Done")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return m.deleteMetric()
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.ChartsView, function (ch) {
                    return _c(
                      "div",
                      {
                        key: ch.ChartId,
                        staticClass: "mt-3",
                        class: ch.ChartCssClass,
                      },
                      [
                        ch.Type === "balancing"
                          ? [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: ch.IsEdited === false,
                                      expression: "ch.IsEdited === false",
                                    },
                                  ],
                                  staticClass: "card",
                                },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c("div", { staticClass: "float-right" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown d-inline mr-2",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-secondary btn-sm",
                                              attrs: {
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [_vm._v("Legend")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right",
                                              attrs: { role: "menu" },
                                            },
                                            _vm._l(
                                              _vm.AlternativesGroups,
                                              function (g) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: g.Name,
                                                    staticClass:
                                                      "dropdown-item-text",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-square",
                                                      style: { color: g.Color },
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(g.Label) +
                                                        "\n                                                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown d-inline" },
                                        [
                                          _vm._m(1, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right",
                                              attrs: { role: "menu" },
                                            },
                                            [
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          ch.IsEdited = true
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Edit")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.cloneChart()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Clone")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.deleteChart()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Delete")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.moveUp()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Move up")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.moveDown()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Move down")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "dropdown-header",
                                                },
                                                [_vm._v("Chart size")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize(
                                                        "Default"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Default")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize("Wide")
                                                    },
                                                  },
                                                },
                                                [_vm._v("Wide")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize("Large")
                                                    },
                                                  },
                                                },
                                                [_vm._v("Large")]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showFullScreen(
                                                        ch
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Full screen")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [_vm._v(_vm._s(ch.Title))]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-body chart-container",
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          "max-width": "100%",
                                          height: "100%",
                                          overflow: "hidden",
                                        },
                                        attrs: { id: `Chart-${ch.ChartId}` },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: ch.IsEdited,
                                      expression: "ch.IsEdited",
                                    },
                                  ],
                                  staticClass: "card",
                                },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c("div", { staticClass: "float-right" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer p-2",
                                          on: {
                                            click: function ($event) {
                                              return ch.stopEditing()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check fa-lg",
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [_vm._v(_vm._s(ch.Title))]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "card-body" }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          height: "40vh",
                                          "max-height": "40vh",
                                          "overflow-y": "auto",
                                          "overflow-x": "hidden",
                                        },
                                      },
                                      [
                                        _c("h6", [_vm._v("Title:")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.trim",
                                              value: ch.Title,
                                              expression: "ch.Title",
                                              modifiers: { trim: true },
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: ch.Title },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                ch,
                                                "Title",
                                                $event.target.value.trim()
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("h6", [_vm._v("Data:")]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: ch.Attribute,
                                                expression: "ch.Attribute",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  ch,
                                                  "Attribute",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { domProps: { value: null } },
                                              [_vm._v("Number of projects")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.NumericAttributes,
                                              function (attr) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: attr.Id,
                                                    domProps: { value: attr },
                                                  },
                                                  [_vm._v(_vm._s(attr.Name))]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        ch.Attribute
                                          ? _c("div", [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: ch.MetricType,
                                                      expression:
                                                        "ch.MetricType",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        ch,
                                                        "MetricType",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.MetricTypes,
                                                  function (t) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: t,
                                                        domProps: { value: t },
                                                      },
                                                      [_vm._v(_vm._s(t))]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("h6", [_vm._v("Statuses:")]),
                                        _vm._v(" "),
                                        _vm._l(
                                          ch.AlternativesStatusIncludes,
                                          function (s) {
                                            return _c("p", { key: s.Id }, [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: s.Included,
                                                    expression: "s.Included",
                                                  },
                                                ],
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    s.Included
                                                  )
                                                    ? _vm._i(s.Included, null) >
                                                      -1
                                                    : s.Included,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = s.Included,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            s,
                                                            "Included",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            s,
                                                            "Included",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        s,
                                                        "Included",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(s.Name) +
                                                  "\n                                        "
                                              ),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-footer text-right" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-success",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return ch.stopEditing()
                                            },
                                          },
                                        },
                                        [_vm._v("Done")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-danger",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return ch.deleteChart()
                                            },
                                          },
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        ch.Type === "scatter"
                          ? [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: ch.IsEdited === false,
                                      expression: "ch.IsEdited === false",
                                    },
                                  ],
                                  staticClass: "card",
                                },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c("div", { staticClass: "float-right" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown d-inline mr-2",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-secondary btn-sm",
                                              attrs: {
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [_vm._v("Legend")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right p-3",
                                              staticStyle: {
                                                "min-width": "400px",
                                              },
                                              attrs: { role: "menu" },
                                            },
                                            [
                                              _c("table", [
                                                _vm._m(2, true),
                                                _vm._v(" "),
                                                _c("tbody", [
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "align-top",
                                                      },
                                                      _vm._l(
                                                        ch.ShapesLegend,
                                                        function (s) {
                                                          return _c(
                                                            "div",
                                                            { key: s.Name },
                                                            [
                                                              _c("i", {
                                                                class:
                                                                  s.ShapeIcon,
                                                              }),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    s.Name
                                                                  ) +
                                                                  "\n                                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "align-top",
                                                      },
                                                      _vm._l(
                                                        _vm.AlternativesGroups,
                                                        function (g) {
                                                          return _c(
                                                            "div",
                                                            { key: g.Name },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-square",
                                                                style: {
                                                                  color:
                                                                    g.Color,
                                                                },
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true",
                                                                },
                                                              }),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    g.Label
                                                                  ) +
                                                                  "\n                                                                "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown d-inline" },
                                        [
                                          _vm._m(3, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right",
                                              attrs: { role: "menu" },
                                            },
                                            [
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          ch.IsEdited = true
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Edit")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.cloneChart()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Clone")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.deleteChart()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Delete")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.moveUp()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Move up")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.moveDown()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Move down")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "dropdown-header",
                                                },
                                                [_vm._v("Chart size")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize(
                                                        "Default"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Default")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize("Wide")
                                                    },
                                                  },
                                                },
                                                [_vm._v("Wide")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize("Large")
                                                    },
                                                  },
                                                },
                                                [_vm._v("Large")]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showFullScreen(
                                                        ch
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Full screen")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [_vm._v(_vm._s(ch.Title))]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-body chart-container",
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          "max-width": "100%",
                                          height: "100%",
                                          overflow: "hidden",
                                        },
                                        attrs: { id: `Chart-${ch.ChartId}` },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: ch.IsEdited,
                                      expression: "ch.IsEdited",
                                    },
                                  ],
                                  staticClass: "card",
                                },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c("div", { staticClass: "float-right" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer p-2",
                                          on: {
                                            click: function ($event) {
                                              return ch.stopEditing()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check fa-lg",
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [_vm._v("Edit chart")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "card-body" }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          height: "40vh",
                                          "max-height": "40vh",
                                          "overflow-y": "auto",
                                          "overflow-x": "hidden",
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v("Chart title:"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model.trim",
                                                        value: ch.Title,
                                                        expression: "ch.Title",
                                                        modifiers: {
                                                          trim: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value: ch.Title,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          ch,
                                                          "Title",
                                                          $event.target.value.trim()
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      "Cumulative axes, order by:"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            ch.RunningTotalOrderAttribute,
                                                          expression:
                                                            "ch.RunningTotalOrderAttribute",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            ch,
                                                            "RunningTotalOrderAttribute",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          domProps: {
                                                            value: null,
                                                          },
                                                        },
                                                        [_vm._v("disabled")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.NumericAttributes,
                                                        function (attr) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              key: attr.Id,
                                                              domProps: {
                                                                value: attr,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  attr.Name
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v("Y Axis:"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            ch.YAxisAttribute,
                                                          expression:
                                                            "ch.YAxisAttribute",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            ch,
                                                            "YAxisAttribute",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.NumericAttributes,
                                                      function (attr) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: attr.Id,
                                                            domProps: {
                                                              value: attr,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(attr.Name)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-6" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v("X Axis:"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            ch.XAxisAttribute,
                                                          expression:
                                                            "ch.XAxisAttribute",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            ch,
                                                            "XAxisAttribute",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.NumericAttributes,
                                                      function (attr) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: attr.Id,
                                                            domProps: {
                                                              value: attr,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(attr.Name)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table table-bordered",
                                          },
                                          [
                                            _vm._m(4, true),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                ch.AlternativesStatusIncludes,
                                                function (s) {
                                                  return _c(
                                                    "tr",
                                                    { key: s.Id },
                                                    [
                                                      _c("td", [
                                                        _vm._v(_vm._s(s.Name)),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value: s.Shape,
                                                                expression:
                                                                  "s.Shape",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  s,
                                                                  "Shape",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.StatusShapes,
                                                            function (shape) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key: shape,
                                                                  domProps: {
                                                                    value:
                                                                      shape,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      shape
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-footer text-right" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-success",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return ch.stopEditing()
                                            },
                                          },
                                        },
                                        [_vm._v("Done")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-danger",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return ch.deleteChart()
                                            },
                                          },
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        ch.Type === "bubble"
                          ? [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: ch.IsEdited === false,
                                      expression: "ch.IsEdited === false",
                                    },
                                  ],
                                  staticClass: "card",
                                },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c("div", { staticClass: "float-right" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown d-inline mr-2",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-secondary btn-sm",
                                              attrs: {
                                                "data-toggle": "dropdown",
                                              },
                                            },
                                            [_vm._v("Legend")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right",
                                              attrs: { role: "menu" },
                                            },
                                            _vm._l(
                                              _vm.AlternativesGroups,
                                              function (g) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: g.Name,
                                                    staticClass:
                                                      "dropdown-item-text",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-square",
                                                      style: { color: g.Color },
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(g.Label) +
                                                        "\n                                                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown d-inline" },
                                        [
                                          _vm._m(5, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown-menu dropdown-menu-right",
                                              attrs: { role: "menu" },
                                            },
                                            [
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          ch.IsEdited = true
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Edit")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.cloneChart()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Clone")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.deleteChart()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Delete")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.moveUp()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Move up")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.rm.Readonly
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return ch.moveDown()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Move down")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "dropdown-header",
                                                },
                                                [_vm._v("Chart size")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize(
                                                        "Default"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Default")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize("Wide")
                                                    },
                                                  },
                                                },
                                                [_vm._v("Wide")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return ch.setSize("Large")
                                                    },
                                                  },
                                                },
                                                [_vm._v("Large")]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "dropdown-divider",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showFullScreen(
                                                        ch
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Full screen")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [_vm._v(_vm._s(ch.Title))]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-body chart-container",
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          "max-width": "100%",
                                          height: "100%",
                                          overflow: "hidden",
                                        },
                                        attrs: { id: `Chart-${ch.ChartId}` },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: ch.IsEdited,
                                      expression: "ch.IsEdited",
                                    },
                                  ],
                                  staticClass: "card",
                                },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c("div", { staticClass: "float-right" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer p-2",
                                          on: {
                                            click: function ($event) {
                                              return ch.stopEditing()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-check fa-lg",
                                          }),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("h5", [_vm._v("Edit chart")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-body" },
                                    [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", [_vm._v("Chart title:")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.trim",
                                              value: ch.Title,
                                              expression: "ch.Title",
                                              modifiers: { trim: true },
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: ch.Title },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                ch,
                                                "Title",
                                                $event.target.value.trim()
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("h6", [_vm._v("Axes:")]),
                                      _vm._v(" "),
                                      _c("p"),
                                      _c("div", { staticClass: "dropdown" }, [
                                        _vm._v(
                                          "\n                                            X Axis:\n                                            "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            attrs: {
                                              "data-toggle": "dropdown",
                                            },
                                          },
                                          [_vm._v(_vm._s(ch.XaxisLabel))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-menu",
                                            staticStyle: {
                                              "overflow-y": "auto",
                                              "max-height": "40vh",
                                            },
                                          },
                                          _vm._l(
                                            _vm.NumericAttributes,
                                            function (attr) {
                                              return _c(
                                                "a",
                                                {
                                                  key: attr.Id,
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      ch.XAxisAttribute = attr
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(attr.Name) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p"),
                                      _vm._v(" "),
                                      _c("p"),
                                      _c("div", { staticClass: "dropdown" }, [
                                        _vm._v(
                                          "\n                                            Y Axis:\n                                            "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            attrs: {
                                              "data-toggle": "dropdown",
                                            },
                                          },
                                          [_vm._v(_vm._s(ch.YaxisLabel))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-menu",
                                            staticStyle: {
                                              "overflow-y": "auto",
                                              "max-height": "40vh",
                                            },
                                          },
                                          _vm._l(
                                            _vm.NumericAttributes,
                                            function (attr) {
                                              return _c(
                                                "a",
                                                {
                                                  key: attr.Id,
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      ch.YAxisAttribute = attr
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(attr.Name) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p"),
                                      _vm._v(" "),
                                      _c("p"),
                                      _c("div", { staticClass: "dropdown" }, [
                                        _vm._v(
                                          "\n                                            Bubble Size:\n                                            "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            attrs: {
                                              "data-toggle": "dropdown",
                                            },
                                          },
                                          [_vm._v(_vm._s(ch.ZAxisOption.Label))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-menu",
                                            staticStyle: {
                                              "overflow-y": "auto",
                                              "max-height": "40vh",
                                            },
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return ch.ZAxisSetEqualCommand()
                                                  },
                                                },
                                              },
                                              [_vm._v("Equal")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return ch.ZAxisSetXYRatioCommand()
                                                  },
                                                },
                                              },
                                              [_vm._v("Ratio: X/Y")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function ($event) {
                                                    return ch.ZAxisSetYXRatioCommand()
                                                  },
                                                },
                                              },
                                              [_vm._v("Ratio: Y/X")]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider",
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.NumericAttributes,
                                              function (attr) {
                                                return _c(
                                                  "a",
                                                  {
                                                    key: attr.Id,
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        return ch.ZAxisSetAttributeCommand(
                                                          attr
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(attr.Name) +
                                                        "\n                                                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("p"),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("h6", [_vm._v("Statuses:")]),
                                      _vm._v(" "),
                                      _vm._l(
                                        ch.AlternativesStatusIncludes,
                                        function (s) {
                                          return _c("p", { key: s.Id }, [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: s.Included,
                                                  expression: "s.Included",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  s.Included
                                                )
                                                  ? _vm._i(s.Included, null) >
                                                    -1
                                                  : s.Included,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a = s.Included,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          s,
                                                          "Included",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          s,
                                                          "Included",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(s, "Included", $$c)
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(s.Name) +
                                                "\n                                    "
                                            ),
                                          ])
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-footer text-right" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-success",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return ch.stopEditing()
                                            },
                                          },
                                        },
                                        [_vm._v("Done")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-danger",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return ch.deleteChart()
                                            },
                                          },
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "bg-light border rounded p-2 mb-1" }, [
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c(
                      "div",
                      { staticClass: "btn-toolbar" },
                      [
                        _vm.SelectedAlternatives.length > 0
                          ? [
                              _c("div", { staticClass: "btn-group mr-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary dropdown-toggle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Edit selected (" +
                                        _vm._s(
                                          _vm.SelectedAlternatives.length
                                        ) +
                                        ")\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-scrollable",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: { click: _vm.showBulkStatusEditor },
                                      },
                                      [_vm._v("Status")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.BulkEditableAttributesBySection,
                                      function (s) {
                                        return _c(
                                          "div",
                                          { key: s.Section },
                                          [
                                            s.Section
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "dropdown-header",
                                                  },
                                                  [_vm._v(_vm._s(s.Section))]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._l(s.Items, function (attr) {
                                              return _c(
                                                "a",
                                                {
                                                  key: attr.Id,
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showBulkAttributeValueEditor(
                                                        attr
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(attr.Name) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              )
                                            }),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "btn-group mr-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-secondary dropdown-toggle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Add to list (" +
                                        _vm._s(
                                          _vm.SelectedAlternatives.length
                                        ) +
                                        ")\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "dropdown-menu" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: _vm.showStaticViewBuilder,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            Create new list\n                                        "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.StaticLists, function (l) {
                                      return _c(
                                        "a",
                                        {
                                          key: l.Id,
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleAddAlternativesToStaticViewCommand(
                                                l.Id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(l.Name) +
                                              "\n                                        "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "btn-group mr-2" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      disabled: !_vm.IsStaticList,
                                    },
                                    on: {
                                      click:
                                        _vm.handleRemoveAlternativesFromStaticViewCommand,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Exclude from list (" +
                                        _vm._s(
                                          _vm.SelectedAlternatives.length
                                        ) +
                                        ")\n                                    "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "btn-group" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: _vm.showAlternativesComparison,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Compare (" +
                                        _vm._s(
                                          _vm.SelectedAlternatives.length
                                        ) +
                                        ")\n                                    "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-2" }, [
                      !_vm.rm.Readonly
                        ? _c(
                            "a",
                            {
                              staticClass: "pointer pr-2",
                              attrs: { title: "Edit columns" },
                              on: { click: _vm.showGridColumnsEditor },
                            },
                            [_c("i", { staticClass: "fa fa-columns fa-lg" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "pointer pr-2",
                          attrs: { title: "Download to spreadsheet" },
                          on: { click: _vm.exportGrid },
                        },
                        [_c("i", { staticClass: "fa fa-download fa-lg" })]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "pbGrid" } }),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-dark", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-lg fa-ellipsis-h" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-dark", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-lg fa-ellipsis-h" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Color")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-dark", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-lg fa-ellipsis-h" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Shape")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-dark", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-lg fa-ellipsis-h" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }